import { render, staticRenderFns } from "./WebPartHRRunner.vue?vue&type=template&id=20854458&scoped=true&"
import script from "./WebPartHRRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartHRRunner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartHRRunner.vue?vue&type=style&index=0&id=20854458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20854458",
  null
  
)

export default component.exports